'use client';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useModalDialogContext } from './modal-dialog.context.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * To pin footers to the bottom of the dialog
   */ pinned: PropTypes.bool
};
/**
 * @subcomponent Dialog
 */ const ModalDialogFooter = createComponent({
    root: 'div',
    displayName: 'ModalDialogFooter',
    propTypes,
    propConfig: {
        derivedProps (props) {
            const { pinned } = props;
            const { setFooterPinned } = useModalDialogContext();
            useEffect(()=>{
                // communicate this value up to the parent so that it can add a class
                setFooterPinned(!!pinned);
                // when the component unmounts, tell the parent that it no longer needs the class
                return ()=>setFooterPinned(undefined);
            }, [
                pinned,
                setFooterPinned
            ]);
            return null;
        },
        classNames: [
            'swan-modal-dialog-footer'
        ]
    }
});

export { ModalDialogFooter };
